import { ErrorOutline } from '@mui/icons-material'
import { Alert, Tooltip } from '@mui/material'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

interface BaseErrorFallbackProps {
  message?: string
}

export const AlertErrorFallback: FC<BaseErrorFallbackProps> = (props) => {
  const { t } = useTranslation('common')
  const message = props.message || t('loadingComponent.defaultErrorFallbackMessage')

  return <Alert severity="error">{message}</Alert>
}

interface IconErrorFallbackProps extends BaseErrorFallbackProps {
  size?: number
}

export const IconErrorFallback: FC<IconErrorFallbackProps> = (props) => {
  const { size = 20 } = props

  const { t } = useTranslation('common')
  const message = props.message || t('loadingComponent.defaultErrorFallbackMessage')

  return (
    <Tooltip title={message} placement="top">
      <ErrorOutline color="error" width={size} height={size} />
    </Tooltip>
  )
}

export const IconButtonErrorFallback: FC<BaseErrorFallbackProps> = (props) => {
  const { t } = useTranslation('common')
  const message = props.message || t('loadingComponent.defaultErrorFallbackMessage')

  return (
    <div style={{ padding: 5 }}>
      <IconErrorFallback size={24} message={message} />
    </div>
  )
}
